import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ChevronRightIcon } from '@domain-group/fe-co-icon';
import { Heading, RowButton, Separator } from '@domain-group/fe-co-allhomes-design-system';
import { MedianPriceCard } from '@domain-group/fe-co-allhomes-shared-components';
import { medianStatProps, articleProps } from '../common-props';
import SuburbArticles from './suburb-articles';
import CtaCard from './cta-card';
import * as styles from './mobile-suburb-info.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MobileSuburbInfo = _ref => {
  var onClick = _ref.onClick,
    medianStatistics = _ref.medianStatistics,
    title = _ref.title,
    description = _ref.description,
    articles = _ref.articles,
    suburbName = _ref.suburbName,
    linkLabel = _ref.linkLabel,
    showSuburbInfoLink = _ref.showSuburbInfoLink,
    suburbInfoLink = _ref.suburbInfoLink,
    onViewMoreInfoClick = _ref.onViewMoreInfoClick;
  return ___EmotionJSX("div", {
    css: styles.mobileSuburbStats
  }, ___EmotionJSX(Heading, {
    title: title || 'Suburb and property insights',
    subtitle: description
  }), medianStatistics && ___EmotionJSX("div", {
    css: styles.medianPrice
  }, ___EmotionJSX(MedianPriceCard, {
    appearance: "horizontal",
    statistics: medianStatistics
  })), showSuburbInfoLink && ___EmotionJSX("div", {
    css: styles.ctaCard
  }, ___EmotionJSX(CtaCard, {
    appearance: "vertical",
    suburbName: suburbName,
    suburbInfoLink: suburbInfoLink,
    onViewMoreInfoClick: onViewMoreInfoClick
  })), ___EmotionJSX(Separator, null), ___EmotionJSX(RowButton, {
    css: styles.link,
    hasPadding: false,
    collapse: true,
    onClick: onClick,
    title: ___EmotionJSX("span", {
      css: styles.linkText
    }, linkLabel),
    rightIcon: ___EmotionJSX(ChevronRightIcon, {
      css: styles.linkIcon
    }),
    leftIcon: null
  }), (articles === null || articles === void 0 ? void 0 : articles.length) > 0 && ___EmotionJSX(Fragment, null, ___EmotionJSX(Separator, null), ___EmotionJSX("div", {
    css: styles.articles
  }, ___EmotionJSX(SuburbArticles, {
    articles: articles,
    suburbName: suburbName
  }))), ___EmotionJSX(Separator, null));
};
MobileSuburbInfo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  suburbName: PropTypes.string,
  articles: PropTypes.arrayOf(PropTypes.shape(articleProps)),
  onClick: PropTypes.func,
  linkLabel: PropTypes.string,
  medianStatistics: PropTypes.shape(medianStatProps),
  showSuburbInfoLink: PropTypes.bool,
  suburbInfoLink: PropTypes.string,
  onViewMoreInfoClick: PropTypes.func
};
MobileSuburbInfo.defaultProps = {
  title: undefined,
  description: null,
  suburbName: '',
  articles: [],
  onClick: () => {},
  linkLabel: 'View insights',
  medianStatistics: {},
  showSuburbInfoLink: true,
  suburbInfoLink: null,
  onViewMoreInfoClick: () => {}
};
export default MobileSuburbInfo;